import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/crm/forecast',
}).lazy(() => import('./forecast.lazy').then((d) => d.Route))
